import { atom } from 'recoil';
import { getConfigVariable } from '../../fn/Config';

// Get the default api version to use
const API_VERSION = getConfigVariable('API_VERSION');

// Check for apiVersion in query parameters
const getApiVersionFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('apiVersion') || urlParams.get('api_version');
};

export const apiVersion = atom({
  key: 'apiVersion',
  default: getApiVersionFromQuery() ?? window?.apiversion ?? API_VERSION,
});
